/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import { DatePicker } from 'antd'
import React from 'react'
import 'moment/locale/en-gb'; // Import the desired locale (e.g., English - United Kingdom)
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
dayjs.extend(customParseFormat);

export default function CustomeDatePicker({
    id,
    classKey,
    format,
    state,
    placeholder,
    handleSelect,
    setdateError,
    termkey,
    disabled,
    imageClass,
    disabledFutureDate,
    setToastErrorMessage,
    showErrorBorder,
    isMandatoryField,
    setsubmitSelected,
    onBlur,defaultValue}) {
    
    const rendercustomdate = (current) => {
        return (
            <div classname="ant-calendar-date" title="">
                {current.date()}
            </div>
        );
    }
    return (
        <div className="relative w-full cursor-pointer">
            <DatePicker
                onClick={() => {if (setToastErrorMessage !== undefined){setToastErrorMessage('')}; if(setsubmitSelected !== undefined) {setsubmitSelected(false)}}}
                daterender={(current)=>rendercustomdate(current)}
                className={`slct-inpt-fld ${showErrorBorder == true ? 'redBorder' : ''} ${(isMandatoryField!=undefined && isMandatoryField === true) ? ' error_border ' : ''}`}
                disabled={disabled}
                disabledDate={disabledFutureDate}
                id={id}
                onBlur={onBlur}
                format={format}
                placeholder={placeholder}
                onChange={(date, dateString) =>
                {handleSelect(id, date, dateString, termkey)
                }
                }
                value={state[id] && dayjs(state[id])}
                suffixIcon={
                    imageClass ? (
                        <img
                            src="/images/calendar.svg"
                            alt="icon"
                            className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-[-20px] w-[20px]"
                        />
                    ) : (
                        <img src="/images/calendar.svg" alt="icon" className="cursor-pointer"/>
                    )
                }
                onFocus={() => setdateError("")}
                allowClear={false}
                title=""
                defaultValue={defaultValue!==undefined?defaultValue:null}
            />
            {/* <img src="/images/calendar.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] right-[13px]" /> */}
        </div>
    );
}
